<template>
    <el-container class="is-vertical" style="flex-shrink: 0">
        <el-main class="stats-viewer">
            <div class="headings">
                <h2>Optimization tasks</h2>
            </div>
            <div class="filters-row">
                <div class="filter-label">Status:</div>
                <el-checkbox-group v-model="status" style="margin-right: 10px">
                    <el-checkbox-button v-for="s in Object.keys(statusMap)" :label="s" :key="s"
                                        @change="filterChange">
                        {{statusMap[s]}}
                    </el-checkbox-button>
                </el-checkbox-group>
                <el-button type="success" class="has-shadow" style="margin-left: auto" @click="getDataDebounce">UPDATE
                </el-button>
            </div>
            <div class="filters-row">
                <div class="filter-label">Queue Name:</div>
                <el-checkbox-group v-model="queueNames" style="margin-right: 10px">
                    <el-checkbox-button v-for="q in queueNamesMap" :label="q" :key="q" @change="filterChange">
                        {{q}}
                    </el-checkbox-button>
                </el-checkbox-group>
                <div style="margin-left: auto">
                    <div class="d-flex">
                    <el-pagination
                            v-model="page"
                            @current-change="pageChange"
                            background
                            style="text-align: center"
                            layout="prev, pager, next"
                            :page-size="limit"
                            :total="total">
                    </el-pagination>
                    <el-select
                            size="small"
                            @change="limitChange"
                            style="width: 65px"
                            v-model="limit"
                            >
                        <el-option :label="5" :value="5"/>
                        <el-option :label="10" :value="10"/>
                        <el-option :label="15" :value="15"/>
                        <el-option :label="25" :value="25"/>
                        <el-option :label="50" :value="50"/>
                    </el-select>
                    </div>
                </div>
            </div>
            <el-table
                    v-if="tableData.length"
                    class="stats-table"
                    :data="tableData"
                    highlight-current-row
                    style="width: 100%">
                <el-table-column
                        label="Data"
                        min-width="250">
                    <template slot-scope="scope">
                        <span>{{scope.row.data}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="QueueName"
                        min-width="80">
                    <template slot-scope="scope">
                        <span>{{scope.row.queueName}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="Status"
                        min-width="150">
                    <template slot-scope="scope">
                        {{statusMap[scope.row.status]}} ({{scope.row.serverName}})
                    </template>
                </el-table-column>
                <el-table-column
                        label="Created"
                        min-width="150">
                    <template slot-scope="scope">
                        {{new Date(scope.row.createdAt).toLocaleDateString()}} {{new
                        Date(scope.row.createdAt).toLocaleTimeString()}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="Started"
                        min-width="150">
                    <template slot-scope="scope">
                                    <span v-if="scope.row.started">
                                        {{new Date(scope.row.started).toLocaleDateString()}} {{new Date(scope.row.started).toLocaleTimeString()}}
                                    </span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="Completed"
                        min-width="150">
                    <template slot-scope="scope">
                                    <span v-if="scope.row.completed">
                                        {{new Date(scope.row.completed).toLocaleDateString()}} {{new Date(scope.row.completed).toLocaleTimeString()}}
                                    </span>
                    </template>
                </el-table-column>
            </el-table>

        </el-main>
    </el-container>
</template>

<script>
  const statusMap = {in_queue: "IN QUEUE", in_proggress: "IN PROGGRESS", complete: "COMPLETE", error: "ERROR"};
  const queueNames = ["optimizeTour", "cropVideo"];
  export default {
    name: 'OptimizeStats',
    data() {
      return {
        page: 1,
        total: 0,
        limit: 10,
        tableData: [],
        tableColumns: ["cooboId", "status", "createdAt", "started", "completed"],

        statusMap: statusMap,
        queueNamesMap: queueNames,
        status: Object.keys(statusMap),
        queueNames: queueNames.slice(),
        interval: null,
        timeout: null,
      }
    },
    mounted() {
      // if (this.$store.state.user.role.name !== "Administrator") {
      //     this.$router.push("/my-library")
      // }
      this.getData();
      this.restartInterval();

    },
    methods: {
      pageChange(page){
        this.page = page;
        this.getDataDebounce();
      },
      limitChange() {
        this.pageChange(1)
      },
      filterChange() {
        this.pageChange(1);
      },
      restartInterval() {
        clearInterval(this.interval);
        this.interval = setInterval(() => {
          this.getData();
        }, 30000)
      },
      getDataDebounce() {
        clearTimeout(this.timeout);
        clearInterval(this.interval);
        this.timeout = setTimeout(() => {
          this.getData();
        }, 500)
      },
      getData() {
        if (!this.status.length) {
          this.tableData = [];
          return;
        }
        let sortQuery = "_sort=updatedAt:DESC"
        let paginationQuery = `_start=${(this.page-1)*this.limit}&_limit=${this.limit}`
        let statusQuery = this.status.length !== this.statusMap.length ? this.status.map(s => "status_in=" + s).join("&") : "";
        let queueNameQuery = this.queueNames.length !== this.queueNamesMap.length ? this.queueNames.map(s => "queueName_in=" + s).join("&") : "";
        let query = "?" + [sortQuery, paginationQuery, statusQuery, queueNameQuery].join("&");
        this.axios.get(this.$store.state.API_URL + 'queuetasks/count' + query).then((response) => {
          this.total = response.data;
          this.axios.get(this.$store.state.API_URL + 'queuetasks' + query).then((response) => {
            this.tableData = response.data;
            this.restartInterval();
          })
        })
      },
    },
    components: {}
  }
</script>



// WEBPACK FOOTER //
// src/pages/OptimizeStats.vue